import { render, staticRenderFns } from "./ManageItems.vue?vue&type=template&id=7b893fc6&"
import script from "./ManageItems.vue?vue&type=script&lang=js&"
export * from "./ManageItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports